import z from "zod";

import type { ErrorClassification } from "../../sentry/classification";

const remiDomainValues = [
  "ACCOUNTING",
  "AGENT_ACTION",
  "AI",
  "AREA_CODE",
  "AUTH",
  "BID",
  "BOUNCIE",
  "COMMUNICATIONS",
  "COMPLIANCE",
  "CONFIG",
  "CONTRACTOR",
  "DOCUMENT",
  "DROPBOX_SIGN",
  "ESCALATION",
  "ESTIMATE",
  "EVENT_STORE",
  "PARTNER_INTEGRATION",
  "FINANCE",
  "GEOGRAPHIC_AREA",
  "HOLDUP",
  "MARKETING",
  "PERSON",
  "PROJECT",
  "PROPERTY_MODEL",
  "QUOTING",
  "REGION",
  "SCHEDULED_EVENTS",
  "SCOPE_OF_WORK",
  "SUNRUN_API",
  "TASK",
  "EXTERNAL",
  "TICKET",
  "MOBILE",
  "PRICE",
  "ADMIN",
  "MATERIALS",
  "TAKE_RATE",
  "WEBHOOK_SENDER",
  "WORK_SITE",
] as const;

const remiDomainSchema = z.enum(remiDomainValues);
export const RemiDomain = remiDomainSchema.enum;
export type RemiDomain = z.infer<typeof remiDomainSchema>;

export type ErrorDetails = {
  classification: ErrorClassification;
  sentryDescription: string;
};

export const RemiDomainDisplayName: Record<RemiDomain, string> = {
  [RemiDomain.ACCOUNTING]: "Accounting",
  [RemiDomain.AGENT_ACTION]: "Agent Action",
  [RemiDomain.AI]: "AI",
  [RemiDomain.AREA_CODE]: "Area Code",
  [RemiDomain.AUTH]: "Auth",
  [RemiDomain.BID]: "Bid",
  [RemiDomain.BOUNCIE]: "Bouncie",
  [RemiDomain.COMMUNICATIONS]: "Communications",
  [RemiDomain.COMPLIANCE]: "Compliance",
  [RemiDomain.CONFIG]: "Config",
  [RemiDomain.CONTRACTOR]: "Contractor",
  [RemiDomain.DOCUMENT]: "Document",
  [RemiDomain.DROPBOX_SIGN]: "Dropbox Sign",
  [RemiDomain.ESCALATION]: "Escalation",
  [RemiDomain.ESTIMATE]: "Estimate",
  [RemiDomain.EVENT_STORE]: "Event Store",
  [RemiDomain.PARTNER_INTEGRATION]: "Partner Integration",
  [RemiDomain.FINANCE]: "Finance",
  [RemiDomain.GEOGRAPHIC_AREA]: "Geographic Area",
  [RemiDomain.HOLDUP]: "Holdup",
  [RemiDomain.MARKETING]: "Marketing",
  [RemiDomain.PERSON]: "Person",
  [RemiDomain.PROJECT]: "Project",
  [RemiDomain.PROPERTY_MODEL]: "Property Model",
  [RemiDomain.QUOTING]: "Quoting",
  [RemiDomain.REGION]: "Region",
  [RemiDomain.SCHEDULED_EVENTS]: "Scheduled Events",
  [RemiDomain.SCOPE_OF_WORK]: "Scope of Work",
  [RemiDomain.SUNRUN_API]: "Sunrun API",
  [RemiDomain.TASK]: "Task",
  [RemiDomain.EXTERNAL]: "External",
  [RemiDomain.TICKET]: "Ticket",
  [RemiDomain.MOBILE]: "Mobile",
  [RemiDomain.PRICE]: "Price",
  [RemiDomain.ADMIN]: "Admin",
  [RemiDomain.MATERIALS]: "Materials",
  [RemiDomain.TAKE_RATE]: "Take Rate",
  [RemiDomain.WEBHOOK_SENDER]: "Webhook Sender",
  [RemiDomain.WORK_SITE]: "Work Site",
};
